import BaseApi from '../../base/base'
import ExamRevisionForm from '../../../forms/exam_revision'
import ExamRevision from '../../../models/exam_revision'

export default class ExamRevisionApi extends BaseApi {
  constructor() {
    super()
  }

  async get(examId, params = {}) {
    this.path = `/admin/exams/${examId}/exam_revisions`
    const response = await this.getRequest(params)
    return response.data.map((element) => {
      return new ExamRevision(element)
    })
  }

  async post(examId, params: ExamRevisionForm) {
    this.path = `/admin/exams/${examId}/exam_revisions`
    const response = await this.postRequest(params)
    return response
  }
}
